import _ from "lodash";
const cache = {
  js: [],
  css: [],
};
const root = global || window;
const curry = (fn) => (...args) =>
  args.length < fn.length ? curry(fn.bind(undefined, ...args)) : fn.apply(undefined, args);
const getExt = curry((src, key) => {
  const ext = root[key];
  // !_.isUndefined(key) && _.isUndefined(ext) && console.warn(`No external named '${key}' in global after loaded ${src}`);
  return ext;
});
const getExternals = (src, externals) =>
  Array.isArray(externals) ? externals.map(getExt(src)) : getExt(src, externals);
const js = (src, externals) => {
  if (cache.js.includes(src)) {
    // console.warn(`[CDN.js] ${src} 已被加载`);
    return Promise.resolve(getExternals(src, externals));
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.setAttribute("src", src);
    script.addEventListener("load", () =>
      setTimeout(() => {
        cache.js.push(src);

        resolve(getExternals(src, externals));
      })
    );
    script.addEventListener("error", reject);
    document.body.appendChild(script);
  });
};
let FB;

export default async function __load__FB() {
  if (FB) {
    return FB;
  }

  FB = await js("https://connect.facebook.net/en_US/sdk.js", "FB");

  FB.init({
    appId: "943837722395618",
    autoLogAppEvents: true,
    xfbml: true,
    version: "v3.0",
    status: true,
  });

  return FB;
}
